import React from 'react'
import logofile from "../assets/logo-no-background.png";
const Logo = ({className}) => {
  return (
    <>
        <img alt="logo" style={{height: 60}} src={logofile}/>
    </>
  )
}

export default Logo